module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-target-modal__modal"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "create-target-modal__header-menu align-center"
  }, [(_vm.svg) ? [_c('svg-icon', {
    staticClass: "create-target-modal__svg",
    attrs: {
      "icon": _vm.svg,
      "width": 60,
      "height": 60
    }
  })] : (_vm.png) ? [_c('img', {
    staticClass: "create-target-modal__svg create-target-modal__png",
    attrs: {
      "src": _vm.png
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-h4 font-weight-medium"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])], 2) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "create-target-modal__loading"
  }, [_c('loading-dots')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'create-target-modal__invisible': _vm.loading
    }
  }, [_vm._t("default"), _vm._v(" "), [_vm._t("create")], _vm._v(" "), [_vm._t("select")]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f1a1620","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/targetSlots/CreateTargetSlot.vue
// module id = 2014
// module chunks = 0